import styled from 'styled-components';

import theme from '@adsk/alloy-react-theme';

const MenuGroupHeader = styled.p`
  display: flex;
  align-items: center;
  margin: 0px;
  padding-left: ${theme.spacing.medium}px;
  height: 32px;
  background: ${theme.colors.charcoal050};
  color: inherit;
  ${theme.typography.bodySmall}
`;

MenuGroupHeader.displayName = 'MenuGroupHeader';

export default MenuGroupHeader;
